export const currentJobPipelineReport = {
  id: 'live_job_pipeline',
  name: 'Current job pipeline',
  description: '',
  visibility: 'private',
  subject_type: 'live_job_pipeline',
  layout: {
    data: [
      // Prospect card hidden — uncomment to show as first tile
      // {
      //   h: 7,
      //   w: 3,
      //   x: 0,
      //   y: 0,
      //   key: '4607',
      //   maxH: 13,
      //   maxW: 6,
      //   minH: 7,
      //   minW: 2,
      // },
      {
        h: 7,
        w: 3,
        x: 0,
        y: 0,
        key: '4601',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 3,
        y: 0,
        key: '4602',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 6,
        y: 0,
        key: '4603',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 3,
        x: 9,
        y: 0,
        key: '4604',
        maxH: 13,
        maxW: 4,
        minH: 7,
        minW: 3,
      },
      {
        h: 23,
        w: 12,
        x: 0,
        y: 7,
        key: '4605',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 30,
        key: '4606',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    // Prospect card hidden — uncomment to show as first tile
    // {
    //   id: 4607,
    //   subject_type: 'live_job_pipeline',
    //   metadata: {
    //     id: 'live_job_pipeline_prospect',
    //     tileKey: 'live_job_pipeline_prospect',
    //     apiParam: 'card',
    //     headerKey: 'prospect',
    //     componentType: 'card',
    //   },
    //   query: null,
    // },
    {
      id: 4601,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_application_review',
        tileKey: 'live_job_pipeline_application_review',
        apiParam: 'card',
        headerKey: 'application_review',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4602,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_interviewed',
        tileKey: 'live_job_pipeline_interviewed',
        apiParam: 'card',
        headerKey: 'interviews',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4603,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_offer',
        tileKey: 'live_job_pipeline_offer',
        apiParam: 'card',
        headerKey: 'offer',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4604,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_hired',
        tileKey: 'live_job_pipeline_hired',
        apiParam: 'card',
        headerKey: 'hired',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4605,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_chart',
        tileKey: 'live_job_pipeline_chart',
        apiParam: 'chart_table',
        headerKeys: [
          'prospect_actual_count',
          'application_review_actual_count',
          'interviews_actual_count',
          'offer_actual_count',
          'hired_actual_count',
        ],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4606,
      subject_type: 'live_job_pipeline',
      metadata: {
        id: 'live_job_pipeline_table',
        tileKey: 'live_job_pipeline_table',
        apiParam: 'chart_table',
        headerKeys: [
          'prospect_actual_count',
          'application_review_actual_count',
          'interviews_actual_count',
          'offer_actual_count',
          'hired_actual_count',
        ],
        componentType: 'table',
        filters: {
          group_by_1: { id: 'job_name', label: 'Job name', key: 'job_name' },
          group_by_2: { id: null, label: 'None' },
          metrics: { id: 'time_in_stage', label: 'Time in stage' },
        },
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
